/*
 *  Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('UploadRequestInterceptor', ['NodesInterceptor', function (NodesInterceptor) {
        return {
            response: function (response) {
                if (angular.isArray(response.resource)) {
                    return response.resource.map(UploadRequestDecorator);
                } else {
                    return UploadRequestDecorator(response.resource);
                }
            }
        };

        function UploadRequestDecorator(uploadRequest) {
            Object.defineProperties(uploadRequest, {
                statusString: {
                    get: function () {
                        if (this.isExpired) {
                            return 'upload_requests_requested_files_table_status_expired';
                        } else if (this.isRevoked) {
                            return 'upload_requests_requested_files_table_status_revoked';
                        } else {
                            return 'upload_requests_requested_files_table_status_active';
                        }
                    }
                },
                isActive: {
                    enumerable: true,
                    get: function () {
                        return !this.isExpired && !this.isRevoked;
                    }
                },
                isPublic: {
                    enumerable: true,
                    get: function() {
                        return this.access_restriction === 'public';
                    }
                },
                isExpired: {
                    enumerable: true,
                    get: function () {
                        return this.expired_at != null;
                    }
                },
                isRevoked: {
                    enumerable: true,
                    get: function () {
                        return this.revoked_at != null;
                    }
                },
                hasRestrictions: {
                    get: function () {
                        return this.hasAllowedExtension || this.hasFilesCountLimit || this.hasFileSizeLimit;
                    }
                },
                hasAllowedExtension: {
                    get: function () {
                        return angular.isArray(this.allowed_file_extensions) && this.allowed_file_extensions.length > 0;
                    }
                },
                hasFilesCountLimit: {
                    get: function () {
                        return angular.isNumber(this.max_file_count) && this.max_file_count > 0;
                    }
                },
                hasFileSizeLimit: {
                    get: function () {
                        return angular.isNumber(this.max_file_size) && this.max_file_size > 0;
                    }
                },
                node: {
                    enumerable: true,
                    configurable: false,
                    writable: false,
                    value: uploadRequest.node != null && uploadRequest.node.isSyncAndShareNodeResource !== true ?
                        NodesInterceptor.response({
                            resource: uploadRequest.node
                        }) :
                        uploadRequest.node
                }
            });

            return uploadRequest;
        }
    }]);
